import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { getStoredRefreshToken } from "@/lib/auth/authStore";
import { useAuthStore } from "@/lib/auth/authStore";
import { Skeleton } from "@/shared/feedback";

export interface PrivateRouteProps {
  children: ReactNode;
}

/**
 * Mbron rruget e aplikacionit ne nivel UX; backend validon sigurine reale.
 */
export const PrivateRoute = ({ children }: PrivateRouteProps): JSX.Element => {
  const location = useLocation();
  const accessToken = useAuthStore((state) => state.accessToken);
  const isBootstrapping = useAuthStore((state) => state.isBootstrapping);
  const hasBootstrapped = useAuthStore((state) => state.hasBootstrapped);
  const refreshToken = getStoredRefreshToken();

  if (isBootstrapping || (!hasBootstrapped && refreshToken)) {
    return (
      <div className="space-y-4 p-6">
        <Skeleton className="h-8 w-64" />
        <Skeleton className="h-40 w-full" />
      </div>
    );
  }

  if (!accessToken && (!refreshToken || hasBootstrapped)) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return <>{children}</>;
};
